export const LOGO =
  "https://cdn.cookielaw.org/logos/dd6b162f-1a32-456a-9cfe-897231c7763c/4345ea78-053c-46d2-b11e-09adaef973dc/Netflix_Logo_PMS.png";

export const USER_PROFILE =
  "https://occ-0-6246-2186.1.nflxso.net/dnm/api/v6/vN7bi_My87NPKvsBoib006Llxzg/AAAABTZ2zlLdBVC05fsd2YQAR43J6vB1NAUBOOrxt7oaFATxMhtdzlNZ846H3D8TZzooe2-FT853YVYs8p001KVFYopWi4D4NXM.png?r=229";

export const LOGIN_BACKGROUND =
  "https://assets.nflxext.com/ffe/siteui/vlv3/058eee37-6c24-403a-95bd-7d85d3260ae1/e10ba8a6-b96a-4308-bee4-76fab1ebd6ca/IN-en-20240422-POP_SIGNUP_TWO_WEEKS-perspective_WEB_db9348f2-4d68-4934-b495-6d9d1be5917e_large.jpg";

export const TMDB_API_OPTIONS = {
  method: 'GET',
  headers: {
    accept: 'application/json',
    Authorization: 'Bearer eyJhbGciOiJIUzI1NiJ9.eyJhdWQiOiJjZTg2YjY3YTM5ZjA3NWEwZjAxNGZkMTU4YTI0Y2ViNCIsInN1YiI6IjY2MmU2NjhhMDcyMTY2MDEyNDY5YzE1MyIsInNjb3BlcyI6WyJhcGlfcmVhZCJdLCJ2ZXJzaW9uIjoxfQ.GfFWQLKxZLmCtzYcjBOuakKKWWUOi0WezomQzZDQFzU'
  }
}

export const IMG_CDN_URL = "https://image.tmdb.org/t/p/w500";

export const Supported_Languages = [
  { identifier: "en", name: "English" },
  { identifier: "hi", name: "Hindi" },
  { identifier: "spanish", name: "Spanish" },
];





export const nowPlayingMovies="https://api.themoviedb.org/3/movie/now_playing?language=en-US&page=1";

  export const IMG_CDN="https://image.tmdb.org/t/p/w500/";

  export const popular="https://api.themoviedb.org/3/movie/popular?language=en-US&page=1";

  export const topRated="https://api.themoviedb.org/3/movie/top_rated?language=en-US&page=1";

  export const upComing="https://api.themoviedb.org/3/movie/upcoming?language=en-US&page=1";

  export const NAV_IMG_URL="https://cdn-icons-png.flaticon.com/128/812/812847.png";

  export const NAV_CROSS_IMG_URL="https://cdn-icons-png.flaticon.com/128/1828/1828666.png";

  export const Trending_Movies_URL="https://api.themoviedb.org/3/trending/movie/day?language=en-US&page=";

  export const Get_Trending_Personalities_URL="https://api.themoviedb.org/3/trending/person/day?language=en-US&page=";

  export const Get_Developer_Info_URL="https://api.github.com/users/mriduldutt";

  export const Error_Img_URL="https://kinsta.com/wp-content/uploads/2021/05/there-has-been-a-critical-error-on-this-website-featured-image.jpeg";

  export const Get_Youtube_Video_URL1="https://www.youtube.com/embed/";

  export const Get_Youtube_Video_URL2="?autoplay=1&mute=1&modestbranding=1&vq=hd1080";

  export const Search_Api_URL1="https://api.themoviedb.org/3/search/multi?query=";

  export const Search_Api_URL2="&include_adult=false&language=en-US&page=1";

  export const Get_Trending_TV_Shows_URL="https://api.themoviedb.org/3/trending/tv/day?language=en-US&page=";

  export const Get_Movie_Info_Url1="https://api.themoviedb.org/3/movie/";

  export const Get_Movie_Info_Url2="?language=en-US";

  export const Get_Movie_Recommendations_Url="/recommendations?language=en-US&page=1";

  export const Get_Movie_Videos_Url="/videos?language=en-US";

  export const Get_Movie_Credits_Url="/credits?language=en-US";

  export const Get_Person_Info_Url1="https://api.themoviedb.org/3/person/";

  export const Get_Person_Info_Url2="language=en-US";

  export const Get_Person_Movies_Url="/movie_credits?language=en-US";

  export const Get_Tv_Show_Info_Url1="https://api.themoviedb.org/3/tv/";

  export const Get_Tv_Show_Info_Url2="?language=en-US";
  
  export const Get_Tv_Show_Credits_Url="/credits?language=en-US";
  